// FIX: Changed firebase imports to scoped packages (@firebase/*).
import { initializeApp } from "@firebase/app";
// By importing the auth module for its side effects, we ensure that the
// auth service is registered with Firebase before we try to use it.
// FIX: Removed v8-style side-effect import, which is not needed in v9 modular SDK.
import { getAuth } from "@firebase/auth";
import { getFirestore } from "@firebase/firestore";
import { getStorage } from "@firebase/storage";
import { getFunctions } from "@firebase/functions";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAUUUF31Eq2tjedUUIlBGHMxoHv2sAYrOc",
  authDomain: "qualified-root-298415.firebaseapp.com",
  projectId: "qualified-root-298415",
  storageBucket: "qualified-root-298415.firebasestorage.app",
  messagingSenderId: "775478026772",
  appId: "1:775478026772:web:ceca1a08fc152f970c7d01"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize and export services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);